<template>
  <mapObjNeu :ueberschrift="'Sammelpunkte'" :mapObj="'sammelpunkte'"/>
</template>

<script>
import mapObjNeu from "@/components/mapObjNeu.vue";

export default {
  name: "SammelpunkteView",
  components: {
    mapObjNeu
  },
  data() {

  },
  methods: {
    
  },
  async created() {
    
  },
  onMounted() {

  },
  setup() {
    
  }
}
</script>
